import { useEffect, useState } from 'react'
import { Navigate } from 'react-router'
import { getMeta } from '../state/db.js'
import { log, reason } from './log.js'
import { ScreenState } from './ScreenState.js'

/**
 * `/`, the manifest start_url. Nothing to show: a fresh phone goes to the parent onboarding, a
 * phone that already carries a parent account goes to the profile picker. The parent session is
 * the `parentSession` meta key (CONTRACTS §8), read here directly so the shell does not pull the
 * parent screens in. A `?inceleme=<code>` on this URL is applied by main.tsx before the router
 * mounts, so the review link works from the root as from any other route.
 */

const logger = log('splash')

type Door = 'pending' | '/veli/onboarding' | '/profil'

export function SplashScreen() {
  const [door, setDoor] = useState<Door>('pending')

  useEffect(() => {
    let cancelled = false
    getMeta('parentSession')
      .then((session) => {
        if (!cancelled) setDoor(session ? '/profil' : '/veli/onboarding')
      })
      .catch((error) => {
        // With no readable store there is no account to pick from: onboarding shows the way in.
        logger.error('could not read the parent session', reason(error))
        if (!cancelled) setDoor('/veli/onboarding')
      })
    return () => {
      cancelled = true
    }
  }, [])

  if (door === 'pending') {
    return (
      <ScreenState status="loading" onRetry={() => window.location.reload()}>
        {null}
      </ScreenState>
    )
  }
  return <Navigate to={door} replace />
}
